import { render, staticRenderFns } from "./ItemRepairStatus.vue?vue&type=template&id=55242a7a"
import script from "./ItemRepairStatus.vue?vue&type=script&lang=js"
export * from "./ItemRepairStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports